import { render, staticRenderFns } from "./PendingShipOrder.vue?vue&type=template&id=be2bd37c&scoped=true"
import script from "./PendingShipOrder.vue?vue&type=script&lang=js"
export * from "./PendingShipOrder.vue?vue&type=script&lang=js"
import style0 from "./PendingShipOrder.vue?vue&type=style&index=0&id=be2bd37c&prod&scoped=true&lang=css"
import style1 from "./PendingShipOrder.vue?vue&type=style&index=1&id=be2bd37c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2bd37c",
  null
  
)

export default component.exports